import React, { createContext, useState } from 'react';

// Create a context
export const MyContext = createContext();

export const MyProvider = ({ children }) => {
    const [notificationData, setNotificationData] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

  return (
    <MyContext.Provider value={{ notificationData, setNotificationData, unreadCount, setUnreadCount }}>
      {children}
    </MyContext.Provider>
  );
};
